import React from 'react'
import {
  Icon,
  OptionsMenu,
  OptionsMenuItem,
  OptionsMenuTrigger,
} from '@deque/cauldron-react'
import { setLanguage, useLanguage } from '../../context/Language'
import isBrowser from '../../lib/is-browser'
import { LanguageCode } from '../../types/language'
import './index.scss'

interface LanguageSelectorProps {
  onSelect?: (languageCode: LanguageCode) => void
}

export default function LanguageSelector(props: LanguageSelectorProps) {
  if (!isBrowser()) {
    // The Provider for the useLanguage() hook is only mounted in the browser,
    // so don't render in SSR/build mode.
    return null
  }

  const { dispatch, state } = useLanguage()

  const onSelect = (languageCode: LanguageCode) => {
    setLanguage(dispatch, languageCode)
    if (props.onSelect) {
      props.onSelect(languageCode)
    }
  }

  const trigger = (props: React.HTMLAttributes<HTMLButtonElement>) => {
    return (
      <OptionsMenuTrigger {...props}>
        <span>{state.language.name}</span>
        <Icon type="chevron-down" />
      </OptionsMenuTrigger>
    )
  }

  // Sort languages so that the current language is first
  const sortedLanguages = state.supportedLanguages.sort((a, b) => {
    if (a.code === state.language.code) return -1
    if (b.code === state.language.code) return 1
    return a.name.localeCompare(b.name)
  })

  return (
    <OptionsMenu className="LanguageSelector" trigger={trigger}>
      {sortedLanguages.map((language) => {
        return (
          <OptionsMenuItem
            key={language.code}
            onSelect={() => onSelect(language.code)}
          >
            <span>{language.name}</span>
          </OptionsMenuItem>
        )
      })}
    </OptionsMenu>
  )
}
